import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {withRouter} from 'react-router-dom';
import ListItem from '../../shared/ListItem';
import Trail from './Trail';

import {getTrails, getTrail} from '../../../sources/Trails';

import withLocationPersistence from '../../hoc/WithLocationPersistence';
import TrayContainerWithHeader from '../../shared/TrayContainerWithHeader';

import {pluralize} from '../../../lib/Helpers';

@inject('mapStore')
@withRouter
@withLocationPersistence
@observer
class Trails extends Component {
  constructor(props) {
    super(props);

    this.TRAIL_TYPES = Object.freeze({
      ALL: 0,
      SHORT: 1,
      LONG: 2
    });

    this.LONG_TRAIL_DURATION = 31;

    this.state = {filter: '', trail_type: this.TRAIL_TYPES.ALL};
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.mapStore.trailId = this.props.match.params.id;
    } else {
      this.props.mapStore.trailId = null;
      getTrails().then((response) => {
        this.props.mapStore.trails.replace(response.data);
        this.setState({items: response.data});
      });
    }
  }

  getTrailsNav() {
    return (
      <div className="trails-nav">
        <button onClick={this.updateStateAndLocationAttribute} name="trail_type" value={this.TRAIL_TYPES.SHORT}>Short
          trails
        </button>
        <button onClick={this.updateStateAndLocationAttribute} name="trail_type" value={this.TRAIL_TYPES.LONG}>Longer
          trails
        </button>
      </div>
    )
  }

  getChildComponent() {
    let child;

    if (this.props.match.params.id && this.props.mapStore.currentItem) {
      let trail = <Trail {...this.props.mapStore.currentItem} />;

      child = <TrayContainerWithHeader title="Showing" trayClass="trail-detail" currentItem={this.props.mapStore.currentItem}
                                       mapStore={this.props.mapStore} params={{path: '/trails', ...this.props.match.params}}>
        {trail}
      </TrayContainerWithHeader>
    } else if (this.props.match.params.id && !this.props.mapStore.currentItem) {
      // loading state
      return <React.Fragment></React.Fragment>
    } else {
      let items = this.props.mapStore.trails.slice();
      items = items.filter((item) => {
        const matches = item.name.match(new RegExp(this.state.filter, "i"));

        let validForCurrentLength = true;

        switch (parseInt(this.state.trail_type, 10)) {
          case this.TRAIL_TYPES.SHORT:
            validForCurrentLength = item.duration <= this.LONG_TRAIL_DURATION;
            break;
          case this.TRAIL_TYPES.LONG:
            validForCurrentLength = item.duration > this.LONG_TRAIL_DURATION;
            break;
          default:
            validForCurrentLength = true;
        }

        return matches && matches.length && validForCurrentLength;
      });

      let results = (<div className="results">
        <div className="scroll-pane">
          {items.map((data, i) => {
            return <ListItem key={`${this.props.match.url}-list-id-${i}`} path={`/trails/${data.id}`} name={data.name}
                             subTitle={`${data.number_stops} ${pluralize('stop', data.number_stops)}, ${data.duration} minutes`}
                             description={data.description} itemType={"trail"} image={data.image}/>
          })}
        </div>
      </div>);

      child = (
        <TrayContainerWithHeader title="Trails" trayClass="trails" params={this.props.match.params}>
          <div className="form-group">
            <input type="text" name="filter" value={this.state.filter} onChange={this.updateStateAndLocationAttribute}
                   placeholder="Search trails..."/>
          </div>

          {this.getTrailsNav()}
          {results}
        </TrayContainerWithHeader>
      )
    }

    return (
      <div>
        {child}
      </div>
    )
  }

  render() {
    return this.getChildComponent();
  }
}

export default Trails;
